<template>
    <div class="canvas-stage-browser" v-if="canvas2_is_ready">
        <a v-for="(stage, index) in visible_stages" :key="stage.slug"
           href="#"
           :style="{background: stage.config.color}"
           :class="{active: activeStage === stage.slug}"
           @click.prevent.stop="browse(stage, index)"
           class="stage">
            <span class="num" :style="{color: stage.config.color}">{{ index + 1 }}</span>
            {{ stage.config.name }}
        </a>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
export default {
    name: "CanvasStageBrowser",
    emits: ['browse'],

    props: {
        // _$$path: Object,
        // uuid: String,
        activeStage: String,
    },

    computed: {

        ...mapGetters('canvas2', ['canvas2_is_ready', 'stages', 'published_canvas_stages']),


        visible_stages(){
            if( this.$page.props.canvas_editable ){
                return this.stages;
            }
            return this.stages.filter((s) => this.published_canvas_stages.indexOf( s.slug ) >= 0 );
        },
    },

    methods: {
        browse(stage, index){
            this.$emit('browse', {stage, index});
        }
    }

}
</script>

<style lang="scss" scoped>
.canvas-stage-browser{
    display: flex;
    position: sticky;
    overflow-x: auto;
    top: 87px;
    z-index: 90;
}
.stage{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: .7rem .5rem;
    flex: 1 1 auto;
    text-align: center;
    text-decoration: none;
    color: white;
    gap: 0.4rem;
    font-size: 1.6rem;
    font-weight: $font-weight-bold;
    text-transform: uppercase;
    line-height: 1;
    position: relative;

    &:before{
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(black, 0.15);
        box-shadow: rgba(black, .5) 0 0 50px inset;
    }

    &.active{

        &:before{
            display: none;

        }
    }

    .num{
        background: white;
        font-size: 1rem;
        width: 1.6rem;
        height: 1.6rem;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        flex-shrink: 0;
    }
    
    @media (max-width: 1199px){
        font-size: 0rem;
        gap: 0;
        &.active{
            font-size: 1.6rem;
            gap: 0.4rem;

            @media (max-width: 650px) {
                font-size: 1rem;
                
                @media (max-width: 400px) {
                    gap: 0;
                    font-size: 0;
                }
            }

            &:before{
                display: none;
            }
        }
    }
}
</style>
